import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateInvoiceOrderFOBActions } from "store/ducks/ordersFob";

export function* updateInvoiceOrderFOBRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/orders-fob/associate-invoice/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateInvoiceOrderFOBActions.success(data));
    notify("success", "Invoice vinculada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateInvoiceOrderFOBActions.failure(errorMessage));
  }
}
